import { formTypes } from "../../../constants/keys";
import styles from "../AnonClaim.module.css";

function RadioGroup({ startClaim, setClaimType, isPersonal }) {
  return (
    <fieldset className={styles.claimRadioFieldset}>
      <legend>
        <h2 className={styles.titleText}>
          Please choose the type of claim to file
        </h2>
      </legend>
      <hr className={styles.hr} />
      <div className={styles.claimRadioGroup}>
        <ul className={styles.anonUL}>
          {isPersonal ? (
            <>
              <li>
                <div className={styles.radioBox}>
                  <input
                    className={styles.radioInput}
                    type="radio"
                    id="home"
                    name="claimType"
                    value={formTypes.Home}
                    onChange={(e) => setClaimType(e.target.value)}
                  />
                  <label className={styles.label} htmlFor="home">
                    Homeowners
                  </label>
                </div>
              </li>
              <li>
                <div className={styles.radioBox}>
                  <input
                    className={styles.radioInput}
                    type="radio"
                    id="auto"
                    name="claimType"
                    value={formTypes.Auto}
                    onChange={(e) => setClaimType(e.target.value)}
                  />
                  <label className={styles.label} htmlFor="auto">
                    Auto
                  </label>
                </div>
              </li>
              <li>
                <div className={styles.radioBox}>
                  <input
                    className={styles.radioInput}
                    type="radio"
                    id="glass"
                    name="claimType"
                    value={formTypes.AutoGlass}
                    onChange={(e) => setClaimType(e.target.value)}
                  />
                  <label className={styles.label} htmlFor="glass">
                    Auto- Glass Only
                  </label>
                </div>
              </li>
            </>
          ) : (
            <>
              <li>
                <div className={styles.radioBox}>
                  <input
                    className={styles.radioInput}
                    type="radio"
                    id="property"
                    name="claimType"
                    value={formTypes.Property}
                    onChange={(e) => setClaimType(e.target.value)}
                  />
                  <label className={styles.label} htmlFor="property">
                    Property
                  </label>
                </div>
              </li>
              <li>
                <div className={styles.radioBox}>
                  <input
                    className={styles.radioInput}
                    type="radio"
                    id="liability"
                    name="claimType"
                    value={formTypes.Liability}
                    onChange={(e) => setClaimType(e.target.value)}
                  />
                  <label className={styles.label} htmlFor="property">
                    General Liability
                  </label>
                </div>
              </li>
              <li>
                <div className={styles.radioBox}>
                  <input
                    className={styles.radioInput}
                    type="radio"
                    id="vehicle"
                    name="claimType"
                    value={formTypes.Vehicle}
                    onChange={(e) => setClaimType(e.target.value)}
                  />
                  <label className={styles.label} htmlFor="vehicle">
                    Company Vehicle
                  </label>
                </div>
              </li>
              <li>
                <div className={styles.radioBox}>
                  <input
                    className={styles.radioInput}
                    type="radio"
                    id="garage"
                    name="claimType"
                    value={formTypes.Garage}
                    onChange={(e) => setClaimType(e.target.value)}
                  />
                  <label className={styles.label} htmlFor="garage">
                    Garage Owners
                  </label>
                </div>
              </li>
            </>
          )}
          <li>
            <button
              className={styles.startButton}
              onClick={startClaim}
              type="button"
            >
              Start Claim
            </button>
          </li>
        </ul>
        <div className={styles.startButtonDiv}></div>
      </div>
    </fieldset>
  );
}

export default RadioGroup;
